export const pages = [
  { path: '/', title: 'Google Search Console optimization' },
  { path: '/setup', title: 'Choose property' },
  { path: '/dashboard', title: 'Search overview' },
  { path: '/profile', title: 'Your account' },
  { path: '/admin', title: 'Manage access' },
  { path: '/billing/success', title: 'Your subscription' },
  { path: '/contact', title: 'Contact' },
];

export function isPagePath(pathname) {
  return pages.some(page => page.path === pathname);
}

export function pageTitle(pathname) {
  return pages.find(page => page.path === pathname)?.title || 'Page not found';
}
